// Aba em que a gaveta do cliente abre na próxima vez — por exemplo, a lista de
// clientes leva direto à aba "Regra" quando o cliente ainda não tem uma. Fica
// fora do store de propósito: o que está no store vai junto ao salvar.
let next = null;

export const openCustomerOnTab = (tab) => { next = tab; };

export const takeCustomerTab = () => {
  const tab = next;
  next = null;
  return tab;
};
